// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"de4fc99e","321":"d0875a9b","453":"5565870f"}[chunkId] + ".chunk.js";
};